import type { EventStatus } from "@vzlive/shared";
import { t, type TranslationKey } from "@vzlive/shared/i18n";
import type { Locale } from "@vzlive/shared";

const keys: Record<EventStatus, TranslationKey> = {
  scheduled: "upcoming",
  hidden: "hidden",
  live: "live",
  paused: "paused",
  archived: "archived",
  removed: "removed",
};

export function StatusBadge({
  status,
  locale,
}: {
  status: EventStatus;
  locale: Locale;
}) {
  return (
    <span className={`status-badge status-badge--${status}`}>
      {status === "live" && <i aria-hidden="true" />}
      {t(locale, keys[status])}
    </span>
  );
}
